import React from 'react';

import AddToCartButton from '../containers/AddToCartButton';
import GalleryCartSummary from '../containers/GalleryCartSummary';
import WrappedBase from './WrappedBase';

export default class GalleryFooterWrapper extends React.Component {
  render() {
    return (
      <WrappedBase>
        <div className="GalleryFooterWrapper">
          <div className="GalleryActionBox__summary">
            <GalleryCartSummary />
          </div>
          <div className="GalleryCartSummary__button ProductFooter__button__container">
            <AddToCartButton
              className="ProductFooter__button"
              {...this.props}
            />
          </div>
        </div>
      </WrappedBase>
    );
  }
}
